import { map, filter } from 'rxjs';

import { OnInit, Component } from '@angular/core';
import { RouterOutlet, NavigationEnd, ActivatedRoute } from '@angular/router';

import { NamedRouter } from '@/app/core/services/named-router';
import { RouteLayout, RouterLayoutService } from '@/app/core/services/router-layout';

import { ToastComponent } from '@/app/shared/components/ui/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private namedRouter: NamedRouter,
    private activatedRoute: ActivatedRoute,
    private routerLayoutService: RouterLayoutService,
  ) {}

  ngOnInit() {
    this.namedRouter.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => this._getRouteLayout(route)),
      )
      .subscribe((layout) => {
        this.routerLayoutService.setLayout(layout);
      });
  }

  private _getRouteLayout(route: ActivatedRoute): RouteLayout {
    let lastRouteWithLayout: RouteLayout | null = null;

    while (route.firstChild) {
      const layout = route.snapshot.data['layout'];
      if (layout) {
        lastRouteWithLayout = layout;
      }
      route = route.firstChild;
    }

    return route.snapshot.data['layout'] || lastRouteWithLayout || RouteLayout.Main;
  }
}
